import { format, isValid } from 'date-fns'
import React from 'react'
import { SimpleCard } from '@opallabs/satellite'
import { styles } from './styles'

interface Props {
  channelList?: string[]
  coverImageUrl?: string
  momentEndDate?: Date
  momentName: string
  momentStartDate?: Date
  storyColor?: string
  storyName?: string
}

export const MomentPreviewCard: React.FC<Props> = ({
  channelList,
  coverImageUrl,
  momentEndDate,
  momentName,
  momentStartDate,
  storyColor,
  storyName,
}) => {
  const stickyNote = (): boolean =>
    channelList !== undefined && channelList.length === 0

  return (
    <SimpleCard cssOverride={styles.card}>
      {coverImageUrl !== undefined ? (
        <SimpleCard.Media
          cssOverride={styles.image}
          imgSource={coverImageUrl}
          altText="Moment Cover Image"
        />
      ) : null}
      <SimpleCard.Generic cssOverride={styles.cardBody(stickyNote())}>
        {storyName !== undefined ? (
          <SimpleCard.Subtitle cssOverride={styles.storyRow}>
            <SimpleCard.Icon
              cssOverride={styles.storyIcon(storyColor)}
              iconSize={18}
              iconName="gem-story-filled-light"
            />
            {storyName}
          </SimpleCard.Subtitle>
        ) : (
          <SimpleCard.Subtitle cssOverride={styles.storyRow}>
            <SimpleCard.Icon
              cssOverride={styles.storyIcon(undefined)}
              iconSize={18}
              iconName="gem-story-filled-light"
            />
            NO STORY
          </SimpleCard.Subtitle>
        )}
        <SimpleCard.Title cssOverride={styles.title}>
          {momentName}
        </SimpleCard.Title>
        {momentStartDate !== undefined &&
        momentEndDate !== undefined &&
        isValid(momentStartDate) &&
        isValid(momentEndDate) ? (
          <SimpleCard.Subtitle cssOverride={styles.dateRange}>
            {format(momentStartDate, 'MM/dd/yy')} -{' '}
            {format(momentEndDate, 'MM/dd/yy')}
          </SimpleCard.Subtitle>
        ) : null}
        {channelList !== undefined && channelList.length > 0 ? (
          <React.Fragment>
            <SimpleCard.Divider cssOverride={styles.divider} />
            <SimpleCard.Generic cssOverride={styles.footer}>
              {channelList.map((iconName) => (
                <div
                  key={`moment-preview-channel-${iconName}`}
                  css={styles.channelIcons}
                >
                  <SimpleCard.Icon
                    iconSize={24}
                    iconName={`gem-channel-${iconName}-filled`}
                  />
                </div>
              ))}
            </SimpleCard.Generic>
          </React.Fragment>
        ) : null}
      </SimpleCard.Generic>
    </SimpleCard>
  )
}
